import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { routes } from '@constants/routes'
import { Box, Container, Toolbar } from '@mui/material'
import { Button } from '@controls/Button'
import { LanguageDropdown } from '@controls/LanguageDropdown'
import { Link } from '@controls/Link'
import { useAdminContext } from '@pages/Admin/AdminContext'
import { AdminHeaderStyled } from './style'

export const AdminHeader: React.FC = () => {
  const { isLoggedIn, logout } = useAdminContext()
  const { t } = useTranslation()

  return (
    <AdminHeaderStyled position="sticky">
      <Container>
        <Toolbar disableGutters className="menu">
          <Box className="title" sx={{ display: { xs: 'none', lg: 'flex' } }}>
            <Link className="title" to={routes.Admin.Index}>
              {t('app.admin.title')}
            </Link>
          </Box>
          {/* TODO: Add highlight for selected menu item */}
          {isLoggedIn && (
            <Box columnGap={2} flex={1} display="flex" alignItems="center">
              <NavLink to={routes.Admin.Options} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.options')}
              </NavLink>
              <NavLink to={routes.Admin.LayoutTypes} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.layout_types')}
              </NavLink>
              <NavLink to={routes.Admin.Buildings} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.buildings')}
              </NavLink>
              <NavLink to={routes.Admin.Houses} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.houses')}
              </NavLink>
              <NavLink to={routes.Admin.Bookings} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.bookings')}
              </NavLink>
              <NavLink to={routes.Admin.Messages} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.messages')}
              </NavLink>
              <NavLink to={routes.Admin.Settings} className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                {t('header.admin.menu.settings')}
              </NavLink>
              <Box display="flex" justifyContent="flex-end">
                <LanguageDropdown color="white" />
              </Box>
              <Box marginLeft="auto">
                <Button className="log-out-btn" color="white" onClick={logout}>
                  {t('pages.admin.header.logout')}
                </Button>
              </Box>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AdminHeaderStyled>
  )
}
